import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import s from "./NotFound.module.scss";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <h1 className={s.status}>404</h1>
        <h2 className={s.title}>Page Not Found</h2>
        <p className={s.text}>
          Oops! The page you’re looking for doesn’t exist or has been moved.
        </p>
        <Button
          className={s.button}
          type="primary"
          onClick={() => navigate("/dashboard")}
        >
          Go Back to Dashboard
        </Button>
      </div>
    </div>
  );
}
